<template>
  <div
    id="login"
    class="container"
  >
    <div class="loginForm">
      <div class="type">
        <span
          v-for="(type, index) in loginType"
          :key="index"
          :class="{ active: typeIndex === index }"
          @click="handleTabClick(index)"
        >
          {{ $t(type) }}</span>
      </div>
      <!-- 账密登录 -->
      <Form
        v-show="typeIndex === 0 && !showChooseStore"
        ref="formAccount"
        class="accountLogin"
        :model="formAccount"
        :rules="ruleAccount"
      >
        <!-- 账密登录不需要regionId -->
        <!-- <FormItem prop="area" class="inputBox">
          <Select
            v-model="formAccount.area"
            :placeholder="$t('login.placeholderArea')"
          >
            <Option
              v-for="item in areaList"
              :key="item.regionId"
              :value="item.regionId"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem> -->
        <!-- 账号 -->
        <FormItem
          class="inputBox"
          prop="account"
        >
          <Input
            v-model="formAccount.account"
            type="text"
            :placeholder="$t('login.placeholderAccount')"
          />
        </FormItem>
        <!-- 密码 -->
        <FormItem prop="pwd">
          <Input
            v-model="formAccount.pwd"
            type="password"
            password
            :placeholder="$t('login.placeholderPwd')"
          />
        </FormItem>
        <!-- 本地验证码 -->
        <FormItem
          class="identifyCode"
          prop="captcha"
        >
          <img
            :src="accountImageCodeBase64"
            alt=""
            class="img-code"
            @click="getImageCode(0)"
          >
          <Input
            v-model="formAccount.captcha"
            type="text"
            :placeholder="$t('login.placeholderCode2')"
            style="width: 1.5rem; position: absolute; right: 0; top: 0"
          />
        </FormItem>
        <div class="loginBtnBox">
          <button
            type="button"
            class="myBtn"
            @click="handleSubmit('formAccount')"
          >
            {{ $t("login.login") }}
          </button>
        </div>
      </Form>
      <!-- 验证码登录 -->
      <Form
        v-show="typeIndex === 1"
        ref="formPhone"
        class="accountLogin"
        :model="formPhone"
        :rules="rulePhone"
      >
        <!-- 区号 -->
        <FormItem
          prop="area"
          class="inputBox"
        >
          <Select
            v-model="formPhone.area"
            :placeholder="$t('login.placeholderArea')"
          >
            <Option
              v-for="item in areaList"
              :key="item.regionId"
              :value="item.regionId"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <!-- 手机号 -->
        <FormItem prop="account">
          <Input
            v-model="formPhone.account"
            type="text"
            :placeholder="$t('login.placeholderCodeLogin')"
          />
        </FormItem>
        <!-- 短信验证码 -->
        <FormItem prop="code">
          <Row
            type="flex"
            justify="space-between"
          >
            <Col span="15">
              <Input
                v-model="formPhone.code"
                :placeholder="$t('login.placeholderCode')"
              />
            </Col>
            <Col span="8">
              <SendCode
                ref="sendCode"
                @click.native="sendCode"
              />
            </Col>
          </Row>
        </FormItem>
        <!-- 本地验证码 -->
        <FormItem
          class="identifyCode"
          prop="captcha"
        >
          <img
            :src="codeLoginImageBase64"
            alt=""
            class="img-code"
            @click="getImageCode(1)"
          >
          <Input
            v-model="formPhone.captcha"
            type="text"
            :placeholder="$t('login.placeholderCode2')"
            style="width: 1.5rem; position: absolute; right: 0; top: 0"
          />
        </FormItem>
        <div class="loginBtnBox">
          <button
            type="button"
            class="myBtn"
            :disabled="clicked"
            @click="handleSubmit('formPhone')"
          >
            {{ $t("login.login") }}
          </button>
        </div>
      </Form>
    </div>
    <!-- 选择店铺 -->
    <div
      v-if="showChooseStore"
      class="chooseStore"
    >
      <h2 class="tc">
        {{ $t("sc.components.chooseStore") }}
      </h2>
      <Select
        v-model="store"
        clearable
        style="width: 200px"
        class="select"
      >
        <Option
          v-for="item in stores"
          :key="item.storeId"
          :value="JSON.stringify(item)"
        >
          {{ item.storeName }}
        </Option>
      </Select>
      <div
        class="tc"
        style="margin-top: 0.8rem"
      >
        <Button @click="storeLogin">
          {{ $t("sc.components.login") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import SendCode from '../../../components/global/send-code.vue'
import { smsCode } from '_h/public'
import { login } from '_h/account'
import { mapGetters } from 'vuex'
import {
  handleLoginSuccess,
  storeLogin as storeLoginFlow,
  getStoreArea,
  sendStoreId as sendStoreIdFlow,
  getUsabled as getUsabledFlow,
  getSellerInfoData as getSellerInfoDataFlow
} from '@/utils/login-flow'
export default {
  components: { SendCode },
  data() {
    // const phoneValidator = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error(this.$t("login.rulePhone")))
    //   } else {
    //     if (/\d/.test(value)) {
    //       callback()
    //     } else callback(new Error(this.$t("login.ruleErrorPhone")))
    //   }
    // }
    return {
      sn: '',
      clicked: false, // 登陆按钮状态
      showChooseStore: false,
      store: '', // stringify Obj
      stores: [],
      areaList: [],
      loginType: ['login.passwordLogin', 'login.codeLogin'],
      accountImageCodeBase64: '',
      codeLoginImageBase64: '',
      typeIndex: 0,
      formAccount: {
        // area: 2,
        account: '',
        captcha: '',
        captchaSn: '',

        pwd: ''
      },
      ruleAccount: {
        account: [
          {
            required: true,
            message: () => this.$t('login.ruleAccount'),
            trigger: 'blur'
          }
        ],
        pwd: [
          {
            required: true,
            message: () => this.$t('login.rulePwd'),
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            trigger: 'blur',
            message: () => this.$t('login.ruleCode')
          }
        ]
      },
      formPhone: {
        area: 2,
        account: '',
        // 手机验/邮箱证码
        code: '',
        sn: '',
        captcha: '',
        captchaSn: ''
      },
      rulePhone: {
        account: [
          {
            required: true,
            trigger: 'blur',
            message: () => this.$t('login.rulePhone')
          }
        ],
        area: [
          {
            type: 'number',
            required: true,
            message: () => this.$t('login.placeholderArea'),
            trigger: 'change'
          }
        ],
        code: [
          {
            required: true,
            message: () => this.$t('login.ruleCode'),
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            trigger: 'blur',
            message: () => this.$t('login.ruleCode')
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['locale'])
  },
  watch: {
    'formPhone.code'() {
      this.clicked = false
    }
  },
  async mounted() {
    if (this.$store.state.isLogin && !this.$route.query?.redirect) {
      this.$router.push('/seller-center/home')
      this.updateMsgSocket()
    }
    this.formPhone.sn = this.$cookies.get('sn-login')
    const { getArea2, getImageCode } = this
    // this.getArea2()
    // this.getImageCode()
    try {
      await Promise.all([
        getArea2(),
        getImageCode()
      ])
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    // 切换tab
    async handleTabClick(index) {
      this.typeIndex = index
      // 切换tab刷新code
      try {
        // 切换tab时重置表单校验
        this.$refs.formAccount.resetFields()
        this.$refs.formPhone.resetFields()

        await this.getImageCode(index)
      } catch (e) {
        console.error(e)
      }
    },
    // 获取图片验证码（base64）
    async getImageCode(type = 0) {
      try {
        const res = await this.$axios.post('/captcha').then(r => r.data)
        const { code, data } = res

        if (code === 0) {
          const { captchaBase64, sn } = data
          if (type === 0) {
            this.accountImageCodeBase64 = captchaBase64
            this.formAccount.captchaSn = sn
          } else {
            this.codeLoginImageBase64 = captchaBase64
            this.formPhone.captchaSn = sn
          }
        }
      } catch (e) {
        console.error(e)
        this.$Message.error(e.response.data.msg)
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.login()
        }
      })
    },
    async sendCode() {
      if (this.$refs.sendCode.timer) {
        return
      }

      const { account, area } = this.formPhone
      const _loginType = this.getLoginType(account)

      if (!account || _loginType === -1) {
        this.$Message.warning(this.$t('login.correctMobilePhoneNumberOrEmailAddress'))
        return
      }

      // 手机号码登录
      if (_loginType === 1) {
        let checkKey = ''

        if (area === 1) {
          checkKey = 'Bangladesh'
        } else if (area === 2) {
          checkKey = 'China'
        }

        const vaild = this.$checkPhone(Number(account), checkKey)

        if (checkKey && !vaild) {
          this.$Message.warning(this.$t('createSellerAccount.step1.reluMsgPhone'))
          return
        }
        const params = { type: 1, regionId: area, phone: account }

        this.getSmsCode(params, 'phoneLogin')
      } else {
        // 邮箱登录
        const params = {
          type: 1,
          email: account,
          regionId: area,
          language: this.locale
        }
        this.getSmsCode(params, 'emailLogin')
      }
    },
    // 获取码验证码(phoneLogin: 手机验证码登录， emailLogin：邮箱验证码登录)
    getSmsCode(params, type = 'phoneLogin') {
      const config = smsCode(params)

      if (type === 'emailLogin') {
        config.url = '/email-code'
      }

      // 防止请求过程中重复点击
      this.$refs.sendCode.isSending = true
      this.$axios
        .request(config)
        .then((res) => {
          if (res.data.code === 0) {
            // this.sn = res.data.data.sn
            const sn = res.data.data.sn
            this.formPhone.sn = sn
            this.$SetCookieFn('sn-login', sn, {
              maxAge: 60 * 15
            })
            // 发送成功再计时
            this.$refs.sendCode.countDown()
          }
        })
        .catch((error) => {
          const err = error.response
          // 恢复获取验证码按钮可点击
          this.$refs.sendCode.isSending = false
          console.error(error)
          if (err?.status >= 500) {
            this.$Message.error(err?.status + err?.statusText)
          }
          if (err.data) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
            // 超过5次跳转主页
            if (err.data.code === 2203) {
              this.$router.push('/') // this.$i18n.path("/"))
            }
          }
        })
    },
    login() {
      const { typeIndex, formAccount, formPhone } = this
      const curLoginParams = typeIndex === 0 ? formAccount : formPhone
      if (!curLoginParams.captchaSn) {
        this.$Message.warning(this.$t('login.ObtainGraphicVerificationCode'))
        return
      }
      const {
        area,
        account,
        captchaSn,
        captcha,
        code,
        sn
      } = curLoginParams

      const params = {
        captchaSn,
        captcha,
        account,
        loginType: 1,
        regionId: area
      }

      if (typeIndex === 1) {
        if (!sn) {
          this.$Message.warning(this.$t('login.obtainVerificationCodeFirst'))
          return
        }
        const _type = this.getLoginType(account)
        // 手机号登录
        if (_type === 1) {
          params.loginType = 2
          params.code = code
          params.sn = sn
          params.phone = account
        } else if (_type === 2) { // 邮箱
          params.loginType = 3
          params.emailCode = code
          params.emailSn = sn
          params.email = account
        } else {
          this.$Message.warning(this.$t('login.correctMobilePhoneNumberOrEmailAddress'))
        }
      } else {
        // 账密登录
        params.password = curLoginParams.pwd
      }

      this.signIn(params)
    },
    /**
     * 1 手机号  2 邮箱
     */
    getLoginType(account) {
      // 验证手机号（其他国家位数不确定，所以这里只匹配是否为纯数字）
      if (/^\d+\d$/.test(account)) {
        return 1
      } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(account)) {
        return 2
      } else {
        return -1
      }
    },
    signIn(reqParam) {
      // 禁用按钮
      this.clicked = true
      this.$axios
        .request(login(reqParam))
        .then((res) => {
          if (res.data.code === 0) {
            // 清除cookie：sn-login
            this.$cookies.remove('sn-login')
            handleLoginSuccess(this, res.data.data)
          }
        })
        .catch((error) => {
          console.error(error)
          const err = error.response
          if (err.status >= 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            // 重置按钮可点击

            // 重置表单code,避免连续点击锁号
            this.formPhone.code = ''
            if (err.data.code === 2251) {
              this.$Message.error(this.$t('createSellerAccount.step1.reluMsgCheckCode'))
            } else this.$Message.error(err.data.msg)
          }
        })
        .finally(() => {
          this.clicked = false
        })
    },
    storeLogin() {
      return storeLoginFlow(this)
    },
    sendStoreId(id) {
      return sendStoreIdFlow(this, id)
    },
    // 获取国家列表数据
    getUsabled() {
      return getUsabledFlow(this)
    },
    // 获取开放的国家
    getArea(storeId) {
      return getStoreArea(this, storeId)
    },
    getArea2() {
      this.$axios
        .get('/national-stations', {
          params: {
            stationType: 1
          }
        })
        .then((response) => {
          this.areaList = response.data.data
          // 平台能开通的国家站
          this.$storage.set('platform-national-stations', response.data.data)
        })
        .catch((error) => {
          console.error(error)
          const err = error.response
          this.spinShow = false
          if (err.status > 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
          }
        })
    },
    async getSellerInfoData() {
      return getSellerInfoDataFlow(this)
    }
  }
}
</script>

<style lang="scss" scoped>
.img-code{
  width: 120px;
  height: 32px;
}
#login {
  width: 100%;
  height: 100%;
  position: relative;
  .loginForm {
    width: 3.8rem;
    margin: 1rem auto;
    border: 1px solid #e3dede;
    border-radius: 8px;
    padding: 0.2rem;
  }
  .type {
    font-size: 0;
    & > span {
      display: inline-block;
      width: 50%;
      font-size: $f16;
      line-height: 0.4rem;
      border-bottom: 2px solid transparent;

      @extend .tc;
      @extend .cr;
    }
  }
  .inputBox {
    margin: 0.2rem 0;
  }
  .loginBtnBox {
    margin: 0.2rem 0 0.1rem;

    & > button {
      width: 100%;
      background-color: $themeColor;
      color: white;
      padding: 0.05rem 0.2rem;
    }

    @extend .tc;
  }
}
.sendCode {
  width: 1rem;
  color: white;
  background-color: $themeColor;
  line-height: 0.32rem;
}
.accountLogin {
  .identifyCode {
    position: relative;
  }
}
.active {
  color: $themeColor;
  font-weight: bold;
  border-bottom-color: $themeColor !important;
}
.chooseStore {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;

  .select {
    margin-top: 0.3rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
